// A promo code from a ?promo= link, kept until the visitor reaches checkout.
const KEY = 'teslp_promo_code';

export const savePromoCode = (code) => {
  try { localStorage.setItem(KEY, String(code || '').trim().toUpperCase().slice(0, 30)); } catch { /* storage blocked */ }
};

export const getPromoCode = () => {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
};

export const clearPromoCode = () => {
  try { localStorage.removeItem(KEY); } catch { /* storage blocked */ }
};
